(function () {
  'use strict';

  const STORAGE_KEY = 'amberjack_wishlist';

  // --- ウィッシュリストの取得・保存 ---
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    updateBadge();
  }

  // --- 追加・削除 ---
  function toggleItem(productData) {
    const list = getWishlist();
    const index = list.findIndex(item => item.id === productData.id);

    if (index >= 0) {
      list.splice(index, 1);
      saveWishlist(list);
      return false;
    } else {
      list.push(productData);
      saveWishlist(list);
      return true;
    }
  }

  function isInWishlist(id) {
    return getWishlist().some(item => String(item.id) === String(id));
  }

  // --- 商品グリッドにハートボタンを追加 ---
  function addHeartButtons() {
    document.querySelectorAll('[data-product-grid]:not([data-wishlist-init])').forEach(item => {
      item.setAttribute('data-wishlist-init', 'true');

      const productId = item.dataset.id;
      const link      = item.querySelector('.grid-product__link');
      const titleEl   = item.querySelector('.grid-product__title');
      const priceEl   = item.querySelector('.grid-product__price');
      const imgEl     = item.querySelector('img');

      if (!productId || !link) return;

      const productData = {
        id    : productId,
        title : titleEl ? titleEl.textContent.trim() : '',
        url   : link.getAttribute('href'),
        image : imgEl ? imgEl.src : '',
        price : priceEl ? priceEl.textContent.trim() : '',
      };

      const btn = document.createElement('button');
      btn.className = 'wishlist-btn';
      btn.setAttribute('aria-label', 'お気に入りに追加');
      btn.innerHTML = `
        <svg viewBox="0 0 24 24" width="20" height="20">
          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
        </svg>
      `;

      if (isInWishlist(productId)) {
        btn.classList.add('is-active');
      }

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const added = toggleItem(productData);
        btn.classList.toggle('is-active', added);
        showToast(added ? 'お気に入りに追加しました' : 'お気に入りから削除しました');
      });

      const content = item.querySelector('.grid-product__content');
      if (content) content.appendChild(btn);
    });
  }

  // --- 商品ページのお気に入りボタン ---
  function addProductPageButton() {
    const btn = document.querySelector('.product-wishlist-btn:not([data-init])');
    if (!btn) return;

    btn.setAttribute('data-init', 'true');

    const productData = {
      id    : btn.dataset.id,
      title : btn.dataset.title,
      url   : btn.dataset.url,
      image : btn.dataset.image,
      price : btn.dataset.price,
    };

    const textEl = btn.querySelector('.product-wishlist-btn__text');

    if (isInWishlist(productData.id)) {
      btn.classList.add('is-active');
      if (textEl) textEl.textContent = 'お気に入りに追加済み';
    }

    btn.addEventListener('click', () => {
      const added = toggleItem(productData);
      btn.classList.toggle('is-active', added);
      if (textEl) {
        textEl.textContent = added ? 'お気に入りに追加済み' : 'お気に入りに追加';
      }
      showToast(added ? 'お気に入りに追加しました' : 'お気に入りから削除しました');
    });
  }

  // --- バッジ更新 ---
  function updateBadge() {
    const count = getWishlist().length;
    document.querySelectorAll('.wishlist-badge').forEach(badge => {
      badge.textContent = count;
      badge.classList.toggle('is-visible', count > 0);
    });
  }

  // --- トースト通知 ---
  function showToast(message) {
    let toast = document.querySelector('.wishlist-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'wishlist-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => {
      toast.classList.remove('is-visible');
    }, 2000);
  }

  // --- お気に入り一覧ページの表示 ---
  function renderWishlistPage() {
    const container = document.getElementById('wishlist-container');
    if (!container) return;

    const list = getWishlist();

    if (list.length === 0) {
      container.innerHTML = `
        <div class="wishlist-empty">
          <p>お気に入りに登録された商品はまだありません</p>
          <a href="/collections/all" class="wishlist-empty__link">商品を見る</a>
        </div>
      `;
      return;
    }

    container.innerHTML = `
      <div class="wishlist-grid">
        ${list.map(item => `
          <div class="wishlist-item" data-id="${item.id}">
            <a href="${item.url}" class="wishlist-item__link">
              <img src="${item.image}" alt="${item.title}" class="wishlist-item__image">
              <div class="wishlist-item__title">${item.title}</div>
              <div class="wishlist-item__price">${item.price}</div>
            </a>
            <button class="wishlist-item__remove" data-remove="${item.id}" aria-label="削除">×</button>
          </div>
        `).join('')}
      </div>
    `;

    container.querySelectorAll('[data-remove]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const id = btn.dataset.remove;
        const newList = getWishlist().filter(i => String(i.id) !== String(id));
        saveWishlist(newList);
        renderWishlistPage();
      });
    });
  }

  // --- 初期化 ---
  function init() {
    addHeartButtons();
    addProductPageButton();
    updateBadge();
    renderWishlistPage();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('page:load', init);

  // 動的追加された商品にも対応
  const mo = new MutationObserver(() => {
    addHeartButtons();
    addProductPageButton();
  });
  mo.observe(document.body, { childList: true, subtree: true });

})();